export default __webpack_public_path__ + "static/media/insights.60691f1c.png";